export default __webpack_public_path__ + "static/media/plus-gray.66913826.svg";